
import { Navbar } from "@/components/Navbar";
import { ProjectTimeTracker } from "@/components/ProjectTimeTracker";
import { TimeEntryList } from "@/components/TimeEntryList";
import { EmployeeHoursCard } from "@/components/EmployeeHoursCard";

const Index = () => {
  return (
    <div className="min-h-screen bg-gray-50 animate-fadeIn flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Main content */}
            <div className="flex-1 min-w-0">
              <div className="rounded-lg border bg-white p-4 sm:p-6 shadow-sm space-y-6">
                <ProjectTimeTracker />
                <TimeEntryList />
              </div>
            </div>

            {/* Side card - only renders for Dekyi */}
            <div className="w-full lg:w-80 lg:flex-shrink-0">
              <EmployeeHoursCard />
            </div>
          </div>
        </div>
      </main>
      <footer className="mt-auto py-4 text-center text-sm text-gray-500">
        product of Walia Solutions
      </footer>
    </div>
  );
};

export default Index;
